import { useState } from 'react';

/**
 * The current values of an AntD form as they are typed, every field possibly
 * unset. `Form.useWatch` types a field as always present, which hides the
 * "nothing typed yet" case that decides whether a submit button is enabled.
 */
export function useFormValues<V extends object>(): {
  values: Partial<V>;
  onValuesChange: (changed: Partial<V>, all: V) => void;
  reset: () => void;
} {
  const [values, setValues] = useState<Partial<V>>({});
  return {
    values,
    onValuesChange: (_changed, all) => {
      setValues(all);
    },
    reset: () => {
      setValues({});
    },
  };
}
